import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ResizedEvent } from 'angular-resize-event';
import { NgxSpinnerService } from 'ngx-spinner';
import io from "socket.io-client";
import { TerminalUI } from 'src/app/core/models/TerminalUi';
import { EnvironmentService } from 'src/app/core/services/environment.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-terminal',
  templateUrl: './terminal.component.html',
  styleUrls: ['./terminal.component.scss']
})
export class TerminalComponent implements OnInit {

  terminal: TerminalUI;
  serverAddress = this.data.serverAddress;
  username: string = this.data.username;
  password: string = this.data.password;
  toggleFullScreen: boolean = false;
  toggleDialog: boolean = false;
  reqFromPod: boolean = this.data.reqFromPod || false;
  podName: string = this.data.podName || '';
  namespace: string = this.data.namespace || 'default';

  defaultHeight: number = 500;
  defaultWidth: number = 300;

  @ViewChild('term', {static: true}) termElement: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<TerminalComponent>,
    @Inject(MAT_DIALOG_DATA) 
    public data: {
      username: string, 
      password: string, 
      serverAddress: string, 
      reqFromPod: boolean,
      podName: string,
      namespace: string,
      headNodeIp: string,
    },
    private spinner: NgxSpinnerService,
    private _snackBar: MatSnackBar,
    private _http: HttpClient,
    private renderer: Renderer2,
    private myElement: ElementRef,
    private _env: EnvironmentService
  ) { }

  ngOnInit(): void {
    this.spinner.show("terminal")
    this.start();
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.terminal?.disconnectSocket();
  }

  onResize(event: ResizedEvent) {
    if(!event.oldRect) return;
    // if(event.newHeight < event.oldHeight || event.newWidth < event.oldWidth){
    //   if(this.toggleFullScreen == false){
    //     this.toggleFullScreen = true
    //   }
    // }
    this.terminal.fit();
  }

  connectToSocket(serverAddress) {
    if (this.reqFromPod) {
      return new Promise(res => {
        const socket = io(serverAddress, {
          withCredentials: false,
          secure: true,
          rejectUnauthorized: false,
          extraHeaders: {
            Cred: btoa(`${this.username}:${this.password}`)
          }
        });
        res(socket);
      });
    }
    else{
      return new Promise(res => {
        const socket = io(serverAddress, {
          path: '/terminal/socket.io/',  
          withCredentials: false,
          secure: true,
          rejectUnauthorized: false,
          extraHeaders: {
            Cred: btoa(`${this.username}:${this.password}`)
          }
        });
        res(socket);
      });
    }
    
  }

  startTerminal(container, socket) {
    this.terminal = new TerminalUI(socket, this.dialogRef, container, this.reqFromPod);
    this.terminal.attachTo(container);
    this.terminal.startListening();
    this.defaultHeight = this.termElement.nativeElement.clientHeight;
    this.defaultWidth = this.termElement.nativeElement.clientWidth;
    this.onResize(new ResizedEvent(
      new DOMRectReadOnly(this.defaultWidth +1, this.defaultHeight + 1), // newRect
      new DOMRectReadOnly(this.defaultWidth, this.defaultHeight) // oldRect
    ));
    this.onFullScreen();
  }

  start() {
    const container = document.getElementById("termContainer");
    container.focus();
    if(this.reqFromPod){
      this.serverAddress = 'https://' + `${this.data.headNodeIp}:${this._env.envVariables.UtilityAccessPort}/terminal/${this.namespace}/${this.podName}`;
      this.connectToSocket(this.serverAddress).then((socket) => {
        this.spinner.hide("terminal");
        this.startTerminal(container, socket);
      },error => {
        this._snackBar.open("Error: Unable to establish a connection", "Ok", {
          duration: 8000
        })
        this.dialogRef.close();
      });
    }
    else{
      this.connectToSocket(this.serverAddress).then((socket) => {
        this.spinner.hide("terminal");
        this.startTerminal(container, socket);
      },error => {
        this._snackBar.open("Error: Unable to establish a connection", "Ok", {
          duration: 8000
        })
        this.dialogRef.close();
      });
    }
  }

  toggleDialogMinMax() {
    if(this.toggleFullScreen && !this.toggleDialog) { 
      this.onFullScreen();
    }
    
    this.toggleDialog = !this.toggleDialog;
        
    const currentElement = this.myElement.nativeElement;
		
		let dialogElement = currentElement.parentElement;
		while (dialogElement && !dialogElement.classList.contains('cdk-overlay-pane')) {
			dialogElement = dialogElement.parentElement;
		}
		
		if (!dialogElement) {
			console.error('Could not find parent overlay pane');
			return;
		}
    
    if(this.toggleDialog) {
      dialogElement.classList.add('minimize2');
      dialogElement.classList.remove('maximize');
    } else {
      dialogElement.classList.remove('minimize2');
      dialogElement.classList.add('maximize');
      
      setTimeout(() => {
        dialogElement.classList.remove('maximize');
      }, 300);
    }
  }

  onFullScreen() {
    if (this.toggleDialog) {
      this.toggleDialogMinMax();
    }
    const customTerminal : any = document.querySelector('.custom-terminal-container');
    if (!this.toggleFullScreen) {
      this.renderer.setStyle(this.termElement.nativeElement, 'height', 'calc(100vh - 3rem)');
      this.renderer.setStyle(this.termElement.nativeElement, 'width', 'calc(100vw - .5rem)');
      customTerminal.style.maxWidth = 'calc(100vw - .5rem)';
    } else {
      this.renderer.removeClass(this.termElement.nativeElement, 'h-98');
      this.renderer.removeClass(this.termElement.nativeElement, 'w-98');
      this.renderer.setStyle(this.termElement.nativeElement, 'height', this.defaultHeight + "px");
      this.renderer.setStyle(this.termElement.nativeElement, 'width', this.defaultWidth + "px");
      customTerminal.style.maxWidth = this.defaultWidth + "px";
    }
    this.terminal.fit();
    this.toggleFullScreen = !this.toggleFullScreen;
  }
}
